<template>
  <el-dialog :title="title" :visible.sync="dialogVisibleState" :width="width" top="9vh">
    <div slot="title">
      <h3 style="font-weight: bold; display: inline-block">{{ title }}</h3>
      <span style="margin-left: 15px" v-if="type === BATCH_COMMANDS_ENUM.EDIT">
        已选 <span class="num-txt">{{ idList.length }}</span> 个素材
      </span>
    </div>
    <div class="modal-wrapper ghost-button-styles">
      <el-form v-if="type === BATCH_COMMANDS_ENUM.EDIT" label-width="140px">
        <el-form-item label="素材名称">
          <el-input v-model.trim="formItem.imageDetailName" :disabled="materialIds.length > 1" placeholder="请填写子素材名称" />
        </el-form-item>

        <el-form-item label="母素材名称">
          <el-input v-model.trim="formItem.imageName" :disabled="materialIds.length > 1" placeholder="请填写母素材名称" />
        </el-form-item>

        <el-form-item label="设计师">
          <el-select v-model="formItem.designerId" filterable clearable placeholder="选择设计师" style="width: 220px; overflow: hidden">
            <el-option v-for="item in sysUserList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

        <template v-if="imageType !== IMAGE_TYPES.STICKERS">
          <el-form-item label="策划师">
            <el-select
              v-model="formItem.plannerId"
              multiple
              collapse-tags
              filterable
              clearable
              placeholder="选择策划师"
              style="width: 220px; overflow: hidden"
            >
              <el-option v-for="item in sysUserList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="一级素材样式"
            v-if="
              [IMAGE_TYPES.IMAGE, IMAGE_TYPES.VIDEO, IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.META, IMAGE_TYPES.PLAYABLE].includes(imageType)
            "
          >
            <el-cascader
              v-model="formItem.imageStyles"
              clearable
              filterable
              style="width: 420px"
              :props="{ label: 'content', value: 'labelId', multiple: true }"
              :options="imageStyleTagList"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item label="3D视频源">
            <el-select
              v-model="formItem.videoLabelIds"
              multiple
              collapse-tags
              filterable
              clearable
              placeholder="选择3D视频源"
              style="width: 420px; overflow: hidden"
            >
              <el-option v-for="label in threedLabeList" :key="label.id" :value="label.id" :label="label.name"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="标签组">
            <el-select
              v-model="formItem.tagGroups"
              multiple
              collapse-tags
              filterable
              clearable
              placeholder="选择标签组"
              style="width: 420px; overflow: hidden"
              @change="onTagGroupsChange"
            >
              <el-option v-for="tag in tagGroupsList" :key="tag.id" :value="tag.id" :label="tag.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="内容标签">
            <ThrottleSelector
              style="width: 420px"
              v-model="formItem.labelIds"
              :list="contentLabelList"
              multiple
              collapse-tags
              filterable
              clearable
              placeholder="选择内容标签"
            />
          </el-form-item> -->

          <el-form-item label="游戏组">
            <el-select
              v-model="formItem.gameGroupIds"
              multiple
              filterable
              clearable
              placeholder="选择游戏组"
              style="width: 420px; overflow: hidden"
              :popper-append-to-body="false"
              @change="handleGroup"
            >
              <el-option v-for="item in gameGroupList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="游戏">
            <el-select
              v-model="formItem.game"
              multiple
              filterable
              clearable
              placeholder="选择游戏"
              style="width: 420px; overflow: hidden"
              @clear="clearGames"
              @remove-tag="clearGames"
            >
              <el-option v-for="item in gameList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>

      <template v-if="type === BATCH_COMMANDS_ENUM.LIMIT">
        <el-form label-width="70px">
          <el-form-item>
            已选 <span class="num-txt">{{ idList.length }}</span> 个素材
          </el-form-item>

          <el-form-item label="限制媒体">
            <el-select
              v-model="formItem.excludeMediaIds"
              multiple
              collapse-tags
              filterable
              clearable
              :popper-append-to-body="false"
              placeholder="选择需要限制投放的媒体"
              style="width: 220px; overflow: hidden"
            >
              <el-option v-for="item in MEDIAS_LIST" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { computed, getCurrentInstance, set as vueSet } from 'vue'
import { isArray } from '@/common/js/utils'
import { MEDIAS_LIST as MEDIAS_LIST_CONST } from '@/common/js/constants'
import { IMAGE_TYPES_STR_VAL as IMAGE_TYPES } from '@/views/material/uploading/consts.js'
import { BATCH_COMMANDS_ENUM as BATCH_COMMANDS_ENUM_CONST } from '../const.js'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { useLabels } from '../../uploading/hooks/useLabelRelations.js'
import { initPageData, SYS_USERS, GAMES, GAME_GROUPS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, GAMES, GAME_GROUPS])

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Boolean
  },
  type: {
    type: Number
  },
  idList: {
    type: Array
  },
  materialIds: {
    type: Array
  },
  formItem: {
    type: Object
  },
  imageType: {
    type: String
  }
})

// eslint-disable-next-line
const emit = defineEmits(['input', 'on-limit', 'on-edit', 'on-cancel'])

// Computed properties for Global Opts
const sysUserList = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const gameList = computed(PAGE_REQUIRED_OPTS.GAMES)
const gameGroupList = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)

// Constants
const MEDIAS_LIST = MEDIAS_LIST_CONST
const BATCH_COMMANDS_ENUM = BATCH_COMMANDS_ENUM_CONST

const formData = computed(() => props.formItem)
const { contentLabelList, threedLabeList, imageStyleTagList, tagGroupsList } = useLabels(formData)

const dialogVisibleState = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})

const title = computed(() => {
  let t
  switch (props.type) {
    case BATCH_COMMANDS_ENUM.EDIT:
      t = '批量修改素材'
      break
    case BATCH_COMMANDS_ENUM.REMOVE:
      t = '批量删除素材'
      break
    case BATCH_COMMANDS_ENUM.LIMIT:
      t = '限制媒体投放'
      break
  }
  return t
})

const width = computed(() => {
  return (props.type === BATCH_COMMANDS_ENUM.EDIT ? 840 : 500) + 'px'
})

// Methods
const onTagGroupsChange = () => {
  // Using vueSet to maintain reactivity if needed, though props.formItem should be reactive
  vueSet(props.formItem, 'labelIds', [])
}

const save = () => {
  if (props.type === BATCH_COMMANDS_ENUM.EDIT) {
    if (!props.formItem.imageName) delete props.formItem.imageName
    if (!props.formItem.imageDetailName) delete props.formItem.imageDetailName
    emit('on-edit', props.formItem)
  } else {
    // 限制媒体投放
    emit('on-limit', props.formItem.excludeMediaIds)
  }
}

const cancel = () => {
  emit('on-cancel')
}

// 选择游戏组
const handleGroup = (val) => {
  const games = []
  const oldGames = JSON.parse(JSON.stringify(props.formItem.game || []))
  if (isArray(val) && val.length) {
    val.forEach((ret) => {
      const index = gameGroupList.value.findIndex((met) => met.id === ret)
      if (index > -1) {
        const { gameIds } = gameGroupList.value[index]
        const child = gameIds.filter((met) => !oldGames.includes(parseInt(met))).map((met) => parseInt(met))
        games.push(...child)
      }
    })
    if (games.length) {
      props.formItem.game.push(...games)
    }
  }
}

// 清空游戏
const clearGames = () => {
  props.formItem.gameGroupIds = []
  props.formItem.imageStyles = []
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  padding: 0 20px;
  position: relative;
  max-height: 650px;
  overflow: auto;
}

::v-deep .num-txt {
  color: red;
  display: inline-block;
}
</style>
